import React from 'react';
import HighlightedLine from '@/components/highlight/HighlightedLine';
import { PoemHighlight } from '@/types/highlights';

// Test data for highlights
const testHighlights: PoemHighlight[] = [
  {
    id: '1',
    poem_id: 'test',
    line_index: 0,
    text: 'sun',
    color: '#FFD700',
    note: 'Imagery of light',
    display_label: 'Light imagery'
  },
  {
    id: '2',
    poem_id: 'test',
    line_index: 0,
    text: 'warm',
    color: '#FF6347',
    note: 'Temperature reference',
    display_label: 'Temperature'
  },
  {
    id: '3',
    poem_id: 'test',
    line_index: 1,
    text: 'darkness',
    color: '#4B0082',
    note: 'Contrast with light',
    display_label: 'Darkness'
  },
  {
    id: '4',
    poem_id: 'test',
    line_index: 1,
    text: 'ebbs away',
    color: '#20B2AA',
    note: 'Movement metaphor',
    display_label: 'Movement'
  },
  {
    id: '5',
    poem_id: 'test',
    line_index: 2,
    text: 'morning',
    color: '#6495ED', 
    note: 'Time of day',
    display_label: 'Time reference'
  }
];

// Test poem content
const testPoem = [
  'The sun rises warm over the horizon',
  'As darkness ebbs away into memory',
  'A new morning breaks with promise'
];

const TestHighlights = () => {
  const [activeHighlight, setActiveHighlight] = React.useState<string | null>(null);
  const [showHighlights, setShowHighlights] = React.useState(true);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Highlight Component Test</h1>
      
      <div className="mb-4">
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={showHighlights}
            onChange={(e) => setShowHighlights(e.target.checked)}
            className="mr-2"
          />
          <span>Show Highlights</span>
        </label>
      </div>
      
      <div className="bg-white p-6 rounded-lg shadow-md mb-6">
        <div className="font-poetry space-y-3 text-lg leading-relaxed mb-4">
          {testPoem.map((line, lineIndex) => (
            <HighlightedLine
              key={lineIndex}
              line={line}
              lineIndex={lineIndex}
              highlights={testHighlights}
              showHighlights={showHighlights}
              activeHighlight={activeHighlight || undefined}
              setActiveHighlight={(id) => setActiveHighlight(id)}
            />
          ))}
        </div>
      </div>
      
      <div className="bg-gray-100 p-4 rounded">
        <h2 className="text-lg font-semibold mb-2">Current State</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <h3 className="font-medium">Active Highlight:</h3>
            <pre className="bg-white p-2 rounded mt-1">
              {activeHighlight ? JSON.stringify(
                testHighlights.find(h => h.id === activeHighlight),
                null, 2
              ) : 'None'}
            </pre>
          </div>
          
          <div>
            <h3 className="font-medium">Debug Info:</h3>
            <pre className="bg-white p-2 rounded mt-1">
              {JSON.stringify({
                highlightCount: testHighlights.length,
                showHighlights
              }, null, 2)}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestHighlights; 